import {Component, Inject, OnInit} from '@angular/core';
import {AuthenticationService} from '@ngx-ivengi/authentication';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html'
})
export class ArchiveComponent implements OnInit {
  public type;

  constructor(
    private authService: AuthenticationService
  ) {
  }

  public ngOnInit(): void {
    this.type = (this.authService.getAuthorizationScopesSync().indexOf('datagrid:EMPLOYEE') !== -1) ? 'EMPLOYEE' : 'CLIENT';
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/archive/archive.component.ts